import { CompanyAction, CompanyActionTypes } from './companyTypes';

export const getCompanies = (): CompanyAction => ({
	type: CompanyActionTypes.USER_GET_COMPANIES_REQUEST
});

export const searchHubspotCompany = (companyName: string): CompanyAction => ({
	type: CompanyActionTypes.SEARCH_HUBSPOT_COMPANY_REQUEST,
	payload: { companyName }
});

export const searchHubspotCompanySuccess = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.SEARCH_HUBSPOT_COMPANY_SUCCESS,
	payload
});

export const searchHubspotCompanyFailure = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.SEARCH_HUBSPOT_COMPANY_FAILURE,
	payload
});

export const clearCompanyErrors = () => ({
	type: CompanyActionTypes.CLEAR_COMPANY_ERRORS
});

export const getCompaniesSuccess = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.USER_GET_COMPANIES_SUCCESS,
	payload
});

export const getCompaniesFailure = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.USER_GET_COMPANIES_FAILURE,
	payload
});

export const createCompany = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.CREATE_COMPANY_REQUEST,
	payload
});

export const createCompanySuccess = (data: any): CompanyAction => ({
	type: CompanyActionTypes.CREATE_COMPANY_SUCCESS,
	payload: data
});

export const createCompanyFailure = (error: any): CompanyAction => ({
	type: CompanyActionTypes.CREATE_COMPANY_FAILURE,
	payload: error
});

export const updateCompany = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.UPDATE_COMPANY_REQUEST,
	payload
});

export const updateCompanySuccess = (data: any): CompanyAction => ({
	type: CompanyActionTypes.UPDATE_COMPANY_SUCCESS,
	payload: data
});

export const updateCompanyFailure = (error): CompanyAction => ({
	type: CompanyActionTypes.UPDATE_COMPANY_FAILURE,
	payload: error
});

export const updateCompanyHsId = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.UPDATE_COMPANY_HS_ID_REQUEST,
	payload
});

export const updateCompanyHsIdSuccess = (data: any): CompanyAction => ({
	type: CompanyActionTypes.UPDATE_COMPANY_HS_ID_SUCCESS,
	payload: data
});

export const updateCompanyHsIdFailure = (error: any): CompanyAction => ({
	type: CompanyActionTypes.UPDATE_COMPANY_HS_ID_FAILURE,
	payload: error
});

export const getCompanyHubspotId = (payload: any): CompanyAction => ({
	type: CompanyActionTypes.GET_COMPANY_HS_ID_REQUEST,
	payload
});

export const getCompanyHubspotIdSuccess = (data: any): CompanyAction => ({
	type: CompanyActionTypes.GET_COMPANY_HS_ID_SUCCESS,
	payload: data
});

export const getCompanyHubspotIdFailure = (error: any): CompanyAction => ({
	type: CompanyActionTypes.GET_COMPANY_HS_ID_FAILURE,
	payload: error
});
